import React, { FC } from 'react'
import { Accordion, AccordionProps } from '@chakra-ui/react'


/**
 * SectionList component to wrap one or more SectionListItem components.
 */
export const SectionList: FC<AccordionProps> = ({
  children,
  ...restProps
}) => (
  <Accordion allowToggle data-testid="section-list-container" {...restProps}>
    {children}
  </Accordion>
)
